import { useLocation, useParams } from "react-router-dom";

export interface RouterParams {
    agreementId: string
    accountId?: string
}

export const useCurrentAccountId = (): string | undefined => {
    const { accountId } = useParams<RouterParams>()
    return accountId
}

export const useCurrentAgreementId = (): string => {
    const { agreementId } = useParams<RouterParams>()
    return agreementId
}